import { Button } from '@roger/ui-components';
import { ClipboardCheck, Download, Upload } from 'lucide-react';

export function FormSchemasHeader({
  catalogLoading,
  catalogEmpty,
  onImport,
  onExport,
  onOpenValidation,
}: {
  catalogLoading: boolean;
  catalogEmpty: boolean;
  onImport: () => void;
  onExport: () => void;
  onOpenValidation: () => void;
}) {
  const actionsDisabled = catalogLoading || catalogEmpty;

  return (
    <div className='flex flex-wrap gap-2 shrink-0'>
      <Button
        type='button'
        variant='outline'
        className='shrink-0'
        disabled={actionsDisabled}
        onClick={onOpenValidation}
      >
        <ClipboardCheck className='h-4 w-4 mr-2' aria-hidden />
        Validation results
      </Button>
      <Button
        type='button'
        variant='outline'
        className='shrink-0'
        disabled={actionsDisabled}
        onClick={onImport}
      >
        <Upload className='h-4 w-4 mr-2' aria-hidden />
        Import…
      </Button>
      <Button
        type='button'
        variant='outline'
        className='shrink-0'
        disabled={actionsDisabled}
        onClick={onExport}
      >
        <Download className='h-4 w-4 mr-2' aria-hidden />
        Export…
      </Button>
    </div>
  );
}
